/* @flow */
import { Record } from '../../transit'

const ListMeta = Record({
  count: null,
  currentPage: 1,
  perPage: 10,
}, 'meta')

export default ListMeta



// WEBPACK FOOTER //
// ./src/common/lib/redux-lists/ListMeta.js